import React, { useEffect, useState } from 'react';

export default function SmoothAnalogClock({ size = 80 }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 100); // Actualización más fluida

    return () => clearInterval(interval);
  }, []);

  const seconds = now.getSeconds() + now.getMilliseconds() / 1000;
  const minutes = now.getMinutes() + seconds / 60;
  const hours = now.getHours() % 12 + minutes / 60;

  const secondDeg = seconds * 6;
  const minuteDeg = minutes * 6;
  const hourDeg = hours * 30;

  const strokeBase = size / 40;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ borderRadius: '50%', background: 'black' }}
    >
      {/* Círculo de fondo */}
      <circle cx="50" cy="50" r="48" stroke="green" strokeWidth={strokeBase * 1.5} fill="white" />

      {/* ✅ --- NUEVO: TEXTO "ACES" DE FONDO --- */}
      <text
        x="50"
        y="50"
        dy="0.3em" // Ajuste vertical fino para centrar mejor
        textAnchor="middle"
        fontSize={size / 5} // Tamaño de fuente proporcional al tamaño del reloj
        fontWeight="bold"
        fill="rgba(0, 0, 0, 0.08)" // Color muy sutil, como una marca de agua
        style={{ userSelect: 'none' }} // Evita que el texto sea seleccionable
      >
        ACES
      </text>

      {/* ✅ --- MARCADORES DE HORA --- */}
      {Array.from({ length: 12 }).map((_, i) => {
        const isHourMark = i % 3 === 0; // Para hacer más grandes las marcas de las 3, 6, 9, 12
        return (
          <line
            key={i}
            x1="50"
            y1={isHourMark ? "8" : "12"}
            x2="50"
            y2="15"
            stroke={isHourMark ? "purple" : "green"}
            strokeWidth={strokeBase * (isHourMark ? 1.2 : 0.8)}
            transform={`rotate(${i * 30} 50 50)`}
          />
        );
      })}

      {/* Manecilla de hora */}
      <line
        x1="50" y1="50" x2="50" y2="30"
        stroke="purple"
        strokeWidth={strokeBase * 1.5}
        strokeLinecap="round"
        transform={`rotate(${hourDeg} 50 50)`}
      />

      {/* Manecilla de minuto */}
      <line
        x1="50" y1="50" x2="50" y2="20"
        stroke="green"
        strokeWidth={strokeBase}
        strokeLinecap="round"
        transform={`rotate(${minuteDeg} 50 50)`}
      />

      {/* Manecilla de segundo */}
      <line
        x1="50" y1="50" x2="50" y2="15"
        stroke="purple"
        strokeWidth={strokeBase * 0.7}
        strokeLinecap="round"
        transform={`rotate(${secondDeg} 50 50)`}
      />

      {/* Centro del reloj */}
      <circle cx="50" cy="50" r={strokeBase * 0.75} fill="white" />
    </svg>
  );
}
